export default {"src":"/_next/static/media/lucidity-logo.77015c5e.svg","height":44,"width":38,"blurWidth":0,"blurHeight":0};